var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SvgLine',{ref:"svgline",on:{"map-finished":_vm.handleMapLoadFinished,"on-click-station":_vm.handleClickStation}}),_c('SvgStationDemand',{ref:"svgStationDemand",attrs:{"actionDate":_vm.actionDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }